export const SEND_MESSAGE = "SEND_MESSAGE";
